<template>
  <van-card
    :price="productInfo.price[0]+'起'"
    :title="productInfo.name"
    :thumb="productInfo.photo_s"
    @click="detail(productInfo)"
    >
        <template #tags>
            <p class="desc">
               {{productInfo.intro}}
            </p>
        </template>
  </van-card>
</template>

<script>
export default {
    props:["productInfo"],
    methods:{
        detail(info){
            console.log("收藏")
            this.$router.push("/productDetails?id="+info.id)
            // pjh if(info.is_report==0){   //未报备
            //     this.$router.push("/productDetails?id="+info.id)
            // }else if(info.is_report==1){  //已报备
            //     // window.location.href=info.out_insure_url;
            //     window.open(info.out_insure_url);
            // }
        }
    },
}
</script>

<style scoped>
    .van-card{  
        box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.14);
        border-radius: 6px;
        margin:0px 12px 12px 12px;
        padding: 13.5px 11px;
        background: rgba(255,255,255,1);
    }
    .van-card__title{
        font-weight: 800;
        color:#222;
        font-size: 15px;
        padding-top: 4px;
        padding-bottom: 8px;
    }
    .van-card__price{
        color:#F34740;
        font-size:11px;
    }
    .van-card__price-integer{
        font-size: 20px;
        font-weight:bold;
    }
    .van-card__thumb{
        width: 103px;
        height: 103px;
        margin-right: 15px;
    }
    .van-card__content{
        padding-top: 2px;
    }
    .van-card__thumb /deep/ img{
        border-radius: 4px;
    }
    .van-card__bottom{
        line-height: 14px;
    }
    .desc{
        color:#666;
        font-size: 12px;
        font-weight: 500;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        /* autoprefixer: on */
        -webkit-line-clamp: 2;  
        /*! autoprefixer: off */
        -webkit-box-orient: vertical;
        margin:0;
    }
</style>


// WEBPACK FOOTER //
// src/components/cellList.vue